// Headset sign-in codes (TV-style "go to gathrxr.com/link"), shared by the
// /link page and the VR code panel. Pure: no Supabase, no DOM. The server
// side (code generation, checks) is supabase/functions/device-link/logic.ts.

/** No 0 / O, 1 / I / L: easy to read off a headset and type on a phone. */
export const CODE_ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
export const CODE_LENGTH = 6;
export const LINK_HOST = 'gathrxr.com';
/** Typed on a phone / computer when the short link isn't handy. */
export const LINK_PAGE_LABEL = `${LINK_HOST}/link`;

/** As the person types: upper-case, alphabet only, at most 6 characters ("k7m-4" -> "K7M4"). */
export function cleanCodeInput(input: string): string {
  let out = '';
  for (const ch of input.toUpperCase()) {
    if (CODE_ALPHABET.includes(ch)) out += ch;
    if (out.length === CODE_LENGTH) break;
  }
  return out;
}

/** The full code from a ?code= value / pasted text, or null when it isn't one. */
export function parseCode(input: string | null | undefined): string | null {
  if (!input) return null;
  const raw = input.toUpperCase().replace(/[\s-]/g, '');
  if (raw.length !== CODE_LENGTH) return null;
  for (const ch of raw) if (!CODE_ALPHABET.includes(ch)) return null;
  return raw;
}

/** "K7M42Q" -> "K7M-42Q" (partial input: "K7M4" -> "K7M-4"). */
export function formatCode(code: string): string {
  return code.length > 3 ? `${code.slice(0, 3)}-${code.slice(3)}` : code;
}

/** "gathrxr.com/l/K7M42Q": the short link shown in the headset. */
export const shortLinkLabel = (code: string) => `${LINK_HOST}/l/${code}`;

/** Site path for /l/:code: the link page with the code filled in. */
export const linkPagePath = (code: string | null | undefined) => {
  const c = parseCode(code ?? null);
  return c ? `/link?code=${c}` : '/link';
};

/** Seconds left as "9:05"; never negative. */
export function formatCountdown(msLeft: number): string {
  const s = Math.max(0, Math.ceil(msLeft / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}
